import { useState } from 'react'
import Swal from 'sweetalert2'
import LeadsService from '@/services/LeadsService'

export function useLeadActions(loadLeadsData) {
	const [isDeleting, setIsDeleting] = useState(false)

	const handleDeleteSelected = async (selectedLeads, clearSelection) => {
		if (selectedLeads.size === 0) {
			Swal.fire({
				title: 'No leads selected',
				text: 'Please select leads to delete',
				icon: 'warning',
			})
			return
		}

		const result = await Swal.fire({
			title: 'Are you sure?',
			text: `You are about to delete ${selectedLeads.size} lead(s). This action cannot be undone!`,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#d33',
			cancelButtonColor: '#3085d6',
			confirmButtonText: 'Yes, delete them!',
			cancelButtonText: 'Cancel',
		})

		if (result.isConfirmed) {
			setIsDeleting(true)
			try {
				const leadIds = Array.from(selectedLeads)
				const deleteResult = await LeadsService.deleteLeads(leadIds)
				console.log(leadIds)

				if (deleteResult.success) {
					Swal.fire({
						title: 'Deleted!',
						text: deleteResult.message || 'Leads have been deleted successfully.',
						icon: 'success',
					})

					// Clear selection and reload data
					clearSelection()
					loadLeadsData()
				} else {
					Swal.fire({
						title: 'Error!',
						text: deleteResult.error || 'Failed to delete leads',
						icon: 'error',
					})
				}
			} catch (error) {
				console.error('Delete leads error:', error)
				Swal.fire({
					title: 'Error!',
					text: 'An unexpected error occurred while deleting leads',
					icon: 'error',
				})
			} finally {
				setIsDeleting(false)
			}
		}
	}

	return {
		isDeleting,
		handleDeleteSelected,
	}
}
